import React, { Component } from "react";

export default class Navbar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            firtsLevel: '',
            secondLevel: '',
            thirdLevel: '',
            fourthLevel: '', 
            isVisible: false,
            initialHeightNavbar: 0,
            heightFixedHeader: 0,
            indexMeganav: 0,
            neddScrollMeganav: false,
            firstHeightMeganav: 0,
            secondHeightMeganav: 0,
            transitionDurationMeganav: '',
            heightMeganavFlex: 0,
            seeAllLabel: "See All ",
        }
        this.escFunction = this.escFunction.bind(this);
        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
        document.addEventListener("keydown", this.escFunction, false);
        window.addEventListener('scroll', this.handleScroll, { passive: true });

        let element = document.getElementById("navbarNav");
        if (element) {
            element.remove();
        } 

        const elementNav = document.querySelectorAll(`[id^="Navbar"]`);
        $(elementNav).addClass("w-100");

        let meganav = document.querySelectorAll(`[id^="meganav"]`);
        let heightMeganav = 0;
        if (meganav && meganav.length > 0) { heightMeganav = meganav[0].offsetHeight; }
        this.setState({ initialHeightNavbar: heightMeganav });
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
        document.removeEventListener("keydown", this.escFunction, false);
        window.removeEventListener('scroll', this.handleScroll);
    };

    handleScroll(event) {
        const { heightFixedHeader, isVisible, indexMeganav, heightMeganavFlex } = this.state;
        const headerInside = document.getElementById("header-inside");
        const headerHome = document.getElementById("header-home");
        if (heightFixedHeader == 0) {
            if (headerHome != null && headerHome.classList.contains("fixed-top")) {
                this.setState({ heightFixedHeader: headerHome.offsetHeight });
                if (this.state.isVisible) {
                    this.checkVisibilityMeganav(indexMeganav, headerHome.offsetHeight, heightMeganavFlex);
                }
            }

            if (headerInside != null && headerInside.classList.contains("fixed-top")) {
                this.setState({ heightFixedHeader: headerInside.offsetHeight });
                if (isVisible) {
                    this.checkVisibilityMeganav(indexMeganav, headerInside.offsetHeight, heightMeganavFlex);
                }
            }
        }
        else if (headerInside != null && headerInside.classList.contains("fixed-top") && heightFixedHeader > headerInside.offsetHeight) {
            this.setState({ heightFixedHeader: headerInside.offsetHeight });
        }
        else if (headerHome != null && headerHome.classList.contains("fixed-top") && heightFixedHeader > headerHome.offsetHeight) {
            this.setState({ heightFixedHeader: headerHome.offsetHeight });
        }
    }
    
    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
            this.setState({
                isVisible: false,
                firtsLevel: '',
                secondLevel: '',
                thirdLevel: '',
                fourthLevel: '',
            });
        }
    }

    escFunction(event) {
        if (event.keyCode === 27) {
            this.setState({
                isVisible: false,
                firtsLevel: '',
                secondLevel: '',
                thirdLevel: '',
                fourthLevel: '',
            });
        }
    }

    setActiveFirstLevel(item, index) {
        this.setState({ indexMeganav: index});
        let firstLevel = document.getElementById("firstLevel"+index);
        let heightFirstLevel = 0;
        let heightMeg = 0;
        if (firstLevel) { heightFirstLevel = firstLevel.offsetHeight; }
        if ((this.state.initialHeightNavbar - 60) < heightFirstLevel) {
            heightMeg = heightFirstLevel + 60;
            this.setState({
                heightMeganavFlex: heightMeg,
                firstHeightMeganav: heightMeg
            });
            setTimeout(() => {
                if (this.state.firtsLevel == item.Title) {
                    this.setState({ firtsLevel: '', secondLevel: '', thirdLevel: '', fourthLevel: '', isVisible: false });
                }
                else {
                    this.setState({ firtsLevel: item.Title, secondLevel: '', thirdLevel: '', fourthLevel: '', isVisible: true });
                }
            }, 200);
        }
        else {
            heightMeg = this.state.initialHeightNavbar;
            this.setState({
                heightMeganavFlex: this.state.initialHeightNavbar,
                firstHeightMeganav: this.state.initialHeightNavbar
            });
            if (this.state.firtsLevel == item.Title) {
                this.setState({ firtsLevel: '', secondLevel: '', thirdLevel: '', fourthLevel: '', isVisible: false });
            }
            else {
                this.setState({ firtsLevel: item.Title, secondLevel: '', thirdLevel: '', fourthLevel: '', isVisible: true });
            }
        }
        setTimeout(() => {
            const headerInside = document.getElementById("header-inside");
            const headerHome = document.getElementById("header-home");
            let heightTop = 0;
            if (headerHome) {
                heightTop = headerHome.offsetHeight;
            }
            else if (headerInside) {
                heightTop = headerInside.offsetHeight;
            }
            this.checkVisibilityMeganav(index, heightTop, heightMeg);
        }, 240);
    }

    setActiveSecondLevel(secondKey, hasChildren, index, findex) {
        let secondLevel = document.getElementById("secondLevel" + index + findex);
        let heightSecondLevel = 0;
        let heightMeg = 0;
        if (secondLevel) { heightSecondLevel = secondLevel.offsetHeight; }

        if ((this.state.firstHeightMeganav - 60) < heightSecondLevel) {
            heightMeg = heightSecondLevel + 60;

            let timeOutNav = heightMeg < this.state.heightMeganavFlex ? 300 : 1;
            let timeOutContent = heightMeg >= this.state.heightMeganavFlex ? 300 : 1;

            setTimeout(() => {
                    this.setState({
                        heightMeganavFlex: heightMeg,
                        transitionDurationMeganav: '200ms',
                        secondHeightMeganav: heightMeg
                    });
            }, timeOutNav);
            
            setTimeout(() => {
                if (this.state.secondLevel != secondKey && hasChildren) {
                    this.setState({ secondLevel: secondKey, thirdLevel: '', fourthLevel: '' });
                }
            }, timeOutContent);

            setTimeout(() => {
                this.setState({
                    transitionDurationMeganav: '',
                });
            }, 301);

        }
        else {

            if (this.state.secondLevel != secondKey && hasChildren) {
                this.setState({ secondLevel: secondKey, thirdLevel: '', fourthLevel: '' });
            }
            heightMeg = this.state.firstHeightMeganav;
            setTimeout(() => {
                this.setState({
                    heightMeganavFlex: this.state.firstHeightMeganav,
                    secondHeightMeganav: this.state.firstHeightMeganav,
                    transitionDurationMeganav: ''
                });
            }, 300);
        }
        setTimeout(() => {
            this.checkVisibilityMeganav(index, 0, heightMeg);
        }, 302);
    }

    setActiveThirdLevel(thirdKey, hasChildren, index, findex, sindex) {
        let thirdLevel = document.getElementById("thirdLevel" + index + findex + sindex);
        let heightThirdLevel = 0;
        let heightMeg = 0;
        if (thirdLevel) { heightThirdLevel = thirdLevel.offsetHeight; }

        if ((this.state.secondHeightMeganav - 60) < heightThirdLevel) {
            heightMeg = heightThirdLevel + 60;

            let timeOutNav = heightMeg < this.state.heightMeganavFlex ? 300 : 1;
            let timeOutContent = heightMeg >= this.state.heightMeganavFlex ? 300 : 1;

            setTimeout(() => {
                this.setState({
                    heightMeganavFlex: heightMeg,
                    transitionDurationMeganav: '200ms',
                });
            }, timeOutNav);

            setTimeout(() => {
                if (this.state.thirdLevel != thirdKey && hasChildren) {
                    this.setState({ thirdLevel: thirdKey, fourthLevel: '' });
                }
            }, timeOutContent);

            setTimeout(() => {
                this.setState({
                    transitionDurationMeganav: '',
                });
            }, 301);

        }
        else {

            if (this.state.thirdLevel != thirdKey && hasChildren) {
                this.setState({ thirdLevel: thirdKey, fourthLevel: '' });
            }
            heightMeg = this.state.secondHeightMeganav;
            setTimeout(() => {
                this.setState({
                    heightMeganavFlex: this.state.secondHeightMeganav,
                    transitionDurationMeganav: ''
                });
            }, 300);
        }
        setTimeout(() => {
            this.checkVisibilityMeganav(index, 0, heightMeg);
        }, 302);
    }

    setActiveFourthLevel(fourthKey) {
        if (this.state.fourthLevel == fourthKey) {
            this.setState({ fourthLevel: '' });
        }
        else {
            this.setState({ fourthLevel: fourthKey });
        }
    }

    checkVisibilityMeganav(index, heightHeader, heightMeg) {
        const { isVisible, heightFixedHeader } = this.state;
        let referenceHeightHeader = heightFixedHeader > 0 ? heightFixedHeader : heightHeader;
        let heightPage = 0;
        if (isVisible && referenceHeightHeader > 0) {
            heightPage += referenceHeightHeader;
            heightPage += heightMeg;
            if (heightPage > window.innerHeight) {
                this.setState({ neddScrollMeganav: true });
            }
            else {
                this.setState({ neddScrollMeganav: false });
            }
        }
    }

    render() {
        const { mainNavItem, removeMeganavDropdown } = this.props;
        const { firtsLevel, secondLevel, thirdLevel, isVisible, neddScrollMeganav, seeAllLabel } = this.state;
        return (
            <div id="navbarNavReact" className="collapse navbar-collapse main-nav w-100" ref={this.wrapperRef}>
                <ul className="navbar-nav primary-nav d-flex w-100 justify-content-between">
                    {mainNavItem && mainNavItem.map((item, index) => {
                        return (
                            <React.Fragment key={index}>
                                <li className={'nav-item  d-flex align-items-center' + ((item.Title === firtsLevel) ? " active" : "")}>
                                    {item.Items.length > 0 && !removeMeganavDropdown &&
                                        <button className={"nav-link " + ((item.Items.length > 0) ? 'has-child' : '')} title={item.Title + " Title"} onClick={this.setActiveFirstLevel.bind(this, item, index)}>
                                            {item.Title}
                                            <i className={'fa-solid fa-angle-down opacity-' + ((item.Items && item.Items.length > 0) ? '1' : '0')}></i>
                                        </button>
                                    }
                                    {((item.Items.length > 0 && removeMeganavDropdown) || item.Items.length <= 0) &&
                                        <a href={item.Link} className={"nav-link " + ((item.Items.length > 0 && removeMeganavDropdown) ? 'has-child' : '')} title={item.Title + " Title"} target={item.OpenInNewWindow ? "_blank" : ""} onClick={!removeMeganavDropdown ? this.setActiveFirstLevel.bind(this, item, index) : () => null }>
                                            {item.Title}
                                            <i className={'fa-solid fa-angle-down opacity-' + ((item.Items && item.Items.length > 0 && !removeMeganavDropdown) ? '1' : '0')}></i>
                                        </a>}
                                    {item.Items && item.Items.length > 0 &&
                                        <div className={(((item.Title == firtsLevel) && isVisible) ? "meganav active" : "meganav")} id={"meganav" + index} style={{ height: this.state.heightMeganavFlex, transitionDuration: this.state.transitionDurationMeganav }} >
                                            <div className={"d-flex w-100" + (neddScrollMeganav ? " meganav-scroll" : "")}>
                                                <div className="close" ><button className="close-menu" onClick={this.setActiveFirstLevel.bind(this, item, index)}><i className="fa-solid fa-xmark"></i> Close menu</button></div>
                                                <div className="item-title mt-2">
                                                    <a href={item.Link} >
                                                        <h2 className="text-white">{item.Title} </h2>
                                                    </a>
                                                </div>
                                                <div className="menu-wrapper">
                                                    <ul className="first-level" id={"firstLevel" + index}>
                                                        {this.props.mainMenuDuplicateFirstLevelLink == true && <li className="nav-link"><a href={item.Link} dangerouslySetInnerHTML={{ __html: item.Title }}></a></li>}

                                                        {item.Items && item.Items.length > 0 && item.Items.map((first, findex) => {
                                                            let secondKey = item.Title + first.Title;
                                                            let firstHasChildren = first.Items && first.Items.length > 0;
                                                            return (
                                                                <li className={"nav-link " + ((secondKey == secondLevel) ? "active" : "")} key={findex} onClick={(e) => {
                                                                    e.stopPropagation()
                                                                    this.setActiveSecondLevel(secondKey, firstHasChildren, index, findex)
                                                                }} >
                                                                    {first.Items && first.Items.length == 0 &&
                                                                        <a href={first.Link} title={first.Title + " Title"} target={first.OpenInNewWindow ? "_blank" : ""}>{first.Title}</a>
                                                                    }
                                                                    {first.Items && first.Items.length > 0 &&
                                                                        <button title={first.Title + " Title"}>{first.Title}
                                                                            <i className="fas fa-arrow-right"></i>
                                                                        </button>
                                                                    }
                                                                    <ul className={"second-level " + ((secondKey == secondLevel) ? "active" : "")} id={'secondLevel' + index + findex} >
                                                                        {first.Link !== "/" && 
                                                                            <li className="nav-link">
                                                                                <a href={first.Link} title={seeAllLabel + first.Title + " Title"} className="fw-bold">{seeAllLabel + first.Title}</a>
                                                                            </li>
                                                                        }
                                                                        {first.Items && first.Items.length > 0 && first.Items.map((second, sindex) => {
                                                                            let thirdKey = item.Title + first.Title + second.Title;
                                                                            let secondHasChildren = second.Items && second.Items.length > 0;
                                                                            return (
                                                                                <li className={"nav-link " + ((thirdKey == thirdLevel) ? "active" : "")} key={sindex} onClick={(e) => {
                                                                                    e.stopPropagation()
                                                                                    this.setActiveThirdLevel(thirdKey, secondHasChildren, index, findex, sindex)
                                                                                }} >
                                                                                    {second.Items && second.Items.length == 0 &&
                                                                                        <a href={second.Link} title={second.Title + " Title"} >{second.Title}</a>
                                                                                    }
                                                                                    {second.Items && second.Items.length > 0 &&
                                                                                        <button title={second.Title + " Title"} >{second.Title}
                                                                                            <i className="fas fa-arrow-right"></i>
                                                                                        </button>
                                                                                    }
                                                                                    <ul className={"third-level " + ((thirdKey == thirdLevel) ? "active" : "")} id={'thirdLevel' + + index + findex + sindex}>
                                                                                        {second.Link !== "/" &&
                                                                                            <li className="nav-link">
                                                                                                <a href={second.Link} title={seeAllLabel + second.Title + " Title"} className="fw-bold">{seeAllLabel + second.Title}</a>
                                                                                            </li>
                                                                                        }
                                                                                        {second.Items && second.Items.length > 0 && second.Items.map((third, tindex) => {
                                                                                            return (
                                                                                                <li className="nav-link" key={tindex}>
                                                                                                    <a href={third.Link} title={third.Title + " Title"} >{third.Title}</a>
                                                                                                </li>
                                                                                            );
                                                                                        })}
                                                                                    </ul>

                                                                                </li>
                                                                            );
                                                                        })}
                                                                    </ul>
                                                                </li>
                                                            );
                                                        })}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    }

                                </li>
                                
                            </React.Fragment>
                        );
                    })}
                    
                    </ul>
                </div>
        );
    }
}